import BackendService from "./BackendService";

async function getTerminals() {
  return BackendService.getData("/machines/");
}
async function getInvoiceFormat(terminalId) {
  return BackendService.getData(`/terminals/${terminalId}/invoice_format/`);
}
async function updateInvoiceFormat(terminalId, data) {
  return BackendService.postData(`/terminals/${terminalId}/invoice_format/`, data);
}

const InvoiceFormatService = {
  getTerminals,
  getInvoiceFormat,
  updateInvoiceFormat,
};

export default InvoiceFormatService;
